import React from "react";
import Margin from "../../Margin";
import PropTypes from "prop-types";
import CompaniesOffers from "./Charts/CompaniesOffers";
import { connect } from "react-redux";
import CompanyOffersByCategory from "./Charts/CompanyOffersByCategory";
import CompaniesCountBySectorTable from "Components/Stats/Tables/CompaniesCountBySectorTable";

/**
 * Composant EntreprisesModule sert à afficher les graphiques de la partie entreprises
 * à l'aide  de primeReact et de composants custom.
 *
 * Les données ainsi ques les options proviennent du dossier Data, et sont
 * stockées grâce aux hooks {@link useState}.
 *
 * Les composants custom utilisés :
 * - {@link Line},
 * - {@link Bar},
 * - {@link Doughnut}
 */
const EntreprisesModule = (props) => {
  // ------------------------------ UNIVERSIÉ ACTUELLE ------------------------------
  const currentUniversity = props.auth.universityConnected || "Erreur";
  // --------------------------------------------------------------------------------

  return (
    <div className="stats_container">
      <CompaniesCountBySectorTable />
      <Margin position="bottom" size="" />
      <CompaniesOffers universityName={currentUniversity.name} />

      <CompanyOffersByCategory universityName={currentUniversity.name} />
    </div>
  );
};

EntreprisesModule.propTypes = {
  auth: PropTypes.any,
  states: PropTypes.any,
  secondaryTables: PropTypes.any,
};

const mapStateToProps = (state) => ({
  states: state.states,
  auth: state.auth,
  secondaryTables: state.secondaryTables,
});

export default connect(mapStateToProps)(EntreprisesModule);
